import { faker } from '@faker-js/faker';

import type { UpdateProfilePostResponse } from '../types/UpdateProfilePostResponse';

export function createUpdateProfilePostResponse(
  data: NonNullable<Partial<UpdateProfilePostResponse>> = {}
): NonNullable<UpdateProfilePostResponse> {
  return {
    ...{
      data: {
        address: faker.string.alpha(),
        birthdate: faker.string.alpha(),
        city: faker.string.alpha(),
        email: faker.string.alpha(),
        name: faker.string.alpha(),
        phone_number: faker.string.alpha(),
        postcode: faker.string.alpha(),
      },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
